import { Sms } from "@mui/icons-material";
import { Box, Button, Tooltip } from "@mui/material";
import { AppFeatureLookup } from "../../App/Constants/AbacConstants";
import { crmLiteUpgradeMessage } from "../../App/Constants/CrmLiteConstants";
import { useFeaturePermission } from "../../App/State/Hooks/abacHooks";
import { ISelectedCandidate } from "../../App/State/Slices/MessageDialogSlice";

export const MessageGroupButton = ({
  isOpen,
  disabled,
  onClick,
  selectedCandidates,
  totalMembers,
}: {
  isOpen: boolean;
  disabled: boolean;
  onClick: () => void;
  selectedCandidates: ISelectedCandidate[];
  totalMembers: number;
}) => {
  const messageGroupButtonAccess = useFeaturePermission(AppFeatureLookup.GroupMessageGroupCampaignButton);
  let title = "Message Group";

  if (selectedCandidates.length === 1) {
    title = "Message Candidate";
  } else if (selectedCandidates.length > 0 && totalMembers !== selectedCandidates.length) {
    title = `Message ${selectedCandidates.length} Candidates`;
  }
  let tooltip = title;

  if (!messageGroupButtonAccess) {
    tooltip = crmLiteUpgradeMessage;
  } else if (disabled) {
    tooltip = "Cannot message an archived group";
  }

  return (
    <Tooltip data-test="message-group-tooltip" title={tooltip} arrow>
      <Box>
        <Button
          startIcon={<Sms />}
          id="message-group-button"
          aria-controls="message-dialog"
          aria-haspopup="true"
          aria-expanded={isOpen}
          // disableElevation
          disabled={disabled || !messageGroupButtonAccess}
          onClick={onClick}
          data-test="message-group-button"
          variant="outlined"
        >
          {title}
        </Button>
      </Box>
    </Tooltip>
  );
};
